import { render, staticRenderFns } from "./PolicyTimeline.vue?vue&type=template&id=c6176246&scoped=true"
import script from "./PolicyTimeline.vue?vue&type=script&lang=js"
export * from "./PolicyTimeline.vue?vue&type=script&lang=js"
import style0 from "./PolicyTimeline.vue?vue&type=style&index=0&id=c6176246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6176246",
  null
  
)

export default component.exports